// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".7cc8ac522f9c6f04bff102e4962a8e76.js";
};